import React from 'react';
import { withRouter, Route, Switch, NavLink, Redirect } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import Personal from './Personal';
import Security from './Security';
import Social from './Social';
import AboutMe from './AboutMe';
import Payout from './Payout';

const TABS = [
  { to: 'personal-settings', label: 'Personal' },
  { to: 'security-settings', label: 'Security' },
  { to: 'social-settings', label: 'Social' },
  { to: 'about-me', label: 'About Me' },
  { to: 'payout-settings', label: 'Payout' },
];

class Settings extends React.Component {

  componentDidMount() {}

  render() {
    const base = this.props.match.url;

    return (
      <Grid container justify="center" style={{ padding: '28px 16px 80px' }}>
        <Grid item xs={12} style={{ maxWidth: 880, width: '100%' }}>
          <div className="inf-hero">
            <div className="inf-hero-inner">
              <p className="inf-hero-kicker">Account</p>
              <h1 className="inf-hero-title">Account Settings</h1>
              <p className="inf-hero-sub">
                Manage your profile, security and connected accounts.
              </p>
            </div>
          </div>

          <div className="inf-tabs">
            {TABS.map((tab) => (
              <NavLink
                key={tab.to}
                to={`${base}/${tab.to}`}
                className="inf-tab"
                activeClassName="active"
              >
                {tab.label}
              </NavLink>
            ))}
          </div>

          <Switch>
            <Route path={`${base}/personal-settings`}>
              <Personal />
            </Route>
            <Route path={`${base}/security-settings`}>
              <Security />
            </Route>
            <Route path={`${base}/social-settings`}>
              <Social />
            </Route>
            <Route path={`${base}/about-me`}>
              <AboutMe />
            </Route>
            <Route path={`${base}/payout-settings`}>
              <Payout />
            </Route>
            <Redirect to={`${base}/personal-settings`} />
          </Switch>
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(Settings);
